import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
  return `${d}. ${months[m - 1]} ${y}`;
};

const CancelInfoStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.afbestil.bk_info).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const onNext = async () => {
    if (!selfServiceData.cancelConfirmed) {return;}
    try {
      const { selfServiceApi } = await import('../../services/selfServiceApi');
      await selfServiceApi.cancelBooking(null, selfServiceData.cancelBookingRef || '');
    } catch { /* ignore mock errors */ }
    goNext();
  };

  return (
    <StepContainer title="Bekræft afbestilling">
      <InfoBox type="warning">
        {body ? body.map((p,i) => <p key={i}>{p}</p>) : <p>Du er ved at afbestille følgende tid:</p>}
        <ul className="summary-list">
          <li><span className="label">Reference</span><span className="value">{selfServiceData.cancelBookingRef}</span></li>
          <li><span className="label">Sted</span><span className="value">{selfServiceData.locationName || ''}</span></li>
          <li><span className="label">Dato</span><span className="value">{selfServiceData.date ? formatDate(selfServiceData.date) : ''}</span></li>
          <li><span className="label">Tid</span><span className="value">{selfServiceData.time ? `kl. ${selfServiceData.time}` : ''}</span></li>
        </ul>
      </InfoBox>
      <fieldset>
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              name="cancelConfirmed"
              checked={!!selfServiceData.cancelConfirmed}
              onChange={(e) => updateSelfServiceData('cancelConfirmed', e.target.checked)}
            />
            <span>Jeg bekræfter, at jeg ønsker at afbestille denne tid</span>
          </label>
        </div>
      </fieldset>
      <NavigationButtons onBack={goBack} onNext={onNext} nextDisabled={!selfServiceData.cancelConfirmed} />
    </StepContainer>
  );
};

export default CancelInfoStep;
